import Axios from "../../Config/API";
import {
    GrupoInterface,
    CadastroGrupoInterface,
} from "../../../Interfaces/Geral/Grupos/GrupoInterfaces";
import Service from "../../Service";

export async function CadastrarGupoService(
    requestBody: CadastroGrupoInterface
) {
    return Service(Axios.post(`/home/grupos/cadastrargrupo`, requestBody));
}

export async function DeletarGrupoService(idGrupo: number) {
    return Service(
        Axios.delete(`/home/grupos/deletargrupo?idGrupo=${idGrupo}`)
    );
}

export async function AtualizarGrupoSerice(requestBody: GrupoInterface) {
    return Service(Axios.put(`/home/grupos/atualizargrupo`, requestBody));
}

export async function GetGrupoService(idGrupo: number) {
    return Service(Axios.get(`/home/grupos/getgrupo?idGrupo=${idGrupo}`));
}

export async function ListarGruposService() {
    return Service(
        Axios.get<Array<GrupoInterface>>(`/home/grupos/listargrupos`)
    );
}

export async function ListarGruposVinculadosModuloService(idModulo: number) {
    return Service(
        Axios.get(
            `/home/grupos/listargruposvinculadosmodulo?idModulos=${idModulo}`
        )
    );
}
